
import Vue from "vue";
import AppAwsFiles from "./AwsFiles.vue";
import { AwsDocument, IAwsDocumentDataSource } from "@/models/base/aws-document";
import { AwsDocumentState } from "@/utils/aws-documents-state";

export default Vue.extend({
	data(){
		return {
			documents: [] as AwsDocument[],
			state: null as null | AwsDocumentState
		};
	},
	props: {
		dataSource: {
			type: Object as ()=>IAwsDocumentDataSource,
			required: true
		}
	},
	methods: {
		cancel(){
			this.$emit("close");
		},
		async save(){
			if (!this.state) return;
			await this.state.save();
			this.state.toAddFiles = [];
			this.$emit("close");
		}
	},
	async mounted(){
		this.documents = await this.dataSource.getDocuments();
		this.state = new AwsDocumentState(this.dataSource, this.documents);
	},
	components: {
		AppAwsFiles
	},
	i18nEx: {
		componentPrefix: "components.purchases"
	}
});
